"use client";

function toggleTheme() {
  const root = document.documentElement;
  const next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
  root.setAttribute("data-theme", next);
  try {
    localStorage.setItem("px-theme", next);
  } catch (e) {}
}

export default function ThemeToggle({ className }) {
  return (
    <button
      type="button"
      className={"px-theme-toggle" + (className ? " " + className : "")}
      aria-label="Toggle dark mode"
      onClick={toggleTheme}
    >
      <svg className="px-theme-icon-light" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <circle cx="9" cy="9" r="4" fill="currentColor" />
        <g stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
          <line x1="9" y1="0.5" x2="9" y2="2.5" />
          <line x1="9" y1="15.5" x2="9" y2="17.5" />
          <line x1="0.5" y1="9" x2="2.5" y2="9" />
          <line x1="15.5" y1="9" x2="17.5" y2="9" />
          <line x1="3.05" y1="3.05" x2="4.46" y2="4.46" />
          <line x1="13.54" y1="13.54" x2="14.95" y2="14.95" />
          <line x1="3.05" y1="14.95" x2="4.46" y2="13.54" />
          <line x1="13.54" y1="4.46" x2="14.95" y2="3.05" />
        </g>
      </svg>
      <svg className="px-theme-icon-dark" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <path
          d="M15.5 10.6A6.6 6.6 0 0 1 7.4 2.5a6.6 6.6 0 1 0 8.1 8.1Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
}
